export const visit = (vm, at) => {
at({ "en": { "data-integrations-breeze": { "filePicker": { "chooseFile": "Choose a spreadsheet file" }, "error": { "connectionFailed": "Couldn't connect to Google", "refreshToTryAgain": "Refresh the page and try again." } } } });
};